import { useEffect, useState } from 'react';
import { api } from '../lib/api';

/**
 * "Listede yok — bu kalemi ürün olarak aç". Ad ve birim faturadan, kod
 * otomatik gelir; kullanıcı isterse hepsini elle değiştirir (elle oluşturma).
 */
export type YeniUrunGirdi = { name: string; code: string; category: string; unit: string };
const BIRIM_AD: Record<string, string> = { KUTU: 'kutu', M2: 'm²', ADET: 'adet', KG: 'kg', LT: 'lt', MTUL: 'metretül' };

export default function KalemdenUrun({ ad, birim, calisiyor, ikinci, ac }: {
  ad: string; birim: string | null; calisiyor: boolean;
  /** İkinci düğme (örn. "Aç, yalnız eşleştir"). */
  ikinci?: string;
  ac: (g: YeniUrunGirdi, ikinciMi: boolean) => void;
}) {
  const [acik, setAcik] = useState(false);
  const [g, setG] = useState<YeniUrunGirdi>({ name: ad, code: '', category: 'ALSAT', unit: 'ADET' });
  useEffect(() => {
    if (!acik) return;
    api<{ code: string; unit: string }>(`/api/alis/urun-oneri?birim=${encodeURIComponent(birim ?? '')}`)
      .then((r) => setG((x) => ({ ...x, code: x.code || r.code, unit: r.unit }))).catch(() => undefined);
  }, [acik, birim]);

  if (!acik) {
    return (
      <button type="button" className="ccd-btn ccd-btn-ghost ccd-btn-sm" onClick={() => { setG((x) => ({ ...x, name: ad })); setAcik(true); }}
              title="Sistemde bu ürün yoksa faturadaki kalemden ürün kartı açar">
        Listede yok — ürün olarak aç
      </button>
    );
  }
  return (
    <div className="ccd-stack-sm" style={{ borderTop: '1px dashed var(--ccd-border)', paddingTop: 10 }}>
      <div className="ccd-meta"><b>Yeni ürün kartı.</b> Faturadaki ad ve birimle doldu; isterseniz değiştirin.</div>
      <div className="ccd-field">
        <label className="ccd-field-label">Ürün adı</label>
        <input className="ccd-input" value={g.name} onChange={(e) => setG({ ...g, name: e.target.value })} />
      </div>
      <div className="ccd-form-grid">
        <div className="ccd-field">
          <label className="ccd-field-label">Ürün kodu</label>
          <input className="ccd-input ccd-mono" value={g.code} placeholder="otomatik"
                 onChange={(e) => setG({ ...g, code: e.target.value.toUpperCase() })} />
        </div>
        <div className="ccd-field">
          <label className="ccd-field-label">Kategori</label>
          <select className="ccd-select" value={g.category} onChange={(e) => setG({ ...g, category: e.target.value })}>
            <option value="ALSAT">Al-sat</option><option value="URETIM">Üretim</option>
            <option value="HAMMADDE">Hammadde</option><option value="HIZMET">Hizmet (stok tutulmaz)</option>
          </select>
        </div>
        <div className="ccd-field">
          <label className="ccd-field-label">Stok birimi</label>
          <select className="ccd-select" value={g.unit} onChange={(e) => setG({ ...g, unit: e.target.value })}>
            {Object.entries(BIRIM_AD).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
        </div>
      </div>
      <div className="ccd-row" style={{ flexWrap: 'wrap', gap: 8 }}>
        <button type="button" className="ccd-btn ccd-btn-primary ccd-btn-sm" disabled={calisiyor || g.name.trim().length < 2}
                onClick={() => ac(g, false)}>{calisiyor ? 'Açılıyor…' : 'Ürünü aç ve bağla'}</button>
        {ikinci && <button type="button" className="ccd-btn ccd-btn-sm" disabled={calisiyor || g.name.trim().length < 2}
                           onClick={() => ac(g, true)}>{ikinci}</button>}
        <button type="button" className="ccd-btn ccd-btn-ghost ccd-btn-sm" onClick={() => setAcik(false)}>Vazgeç</button>
      </div>
    </div>
  );
}
